import React, { useState, useEffect, useRef } from 'react';
import ApiService from '../../../services/apiService';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import './employee.css';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import userManagement from '../../../services/userManagement';
import { shiftEnums } from '../../../../Enums/config';
import { FaSave } from 'react-icons/fa';
import { FaAngleLeft } from 'react-icons/fa6';

const AddEmployee = () => {
  let navigate = useNavigate();
  const location = useLocation();
  const [Restaurants, setRestaurant] = useState([]);
  const [branches, setBranches] = useState([]);
  const [selectedRestaurant, setSelectedRestaurant] = useState(null);

  // 🔹 Single-branch selection (non-admin)
  const [selectedBranch, setSelectedBranch] = useState(null);
  // 🔹 Multi-branch selection (admin)
  const [selectedBranches, setSelectedBranches] = useState([]);
  // 🔹 Flag: is selected user/role Admin?
  const [isAdminUser, setIsAdminUser] = useState(false);

  const [selectedShift, setSelectedShift] = useState(null);
  const [Roles, setRoles] = useState([]);
  const { t } = useTranslation();
  const [selectedRole, setSelectedRole] = useState([]);
  const [userList, setUserList] = useState([]);
  const [CostTab, setCostTab] = useState(true);
  const [detail, setDetail] = useState(true);
  let token = localStorage.getItem('Token');
  let userID = userManagement.getUserId(token);
  const [otp, setOTP] = useState(['', '', '', '']); // State to hold OTP values
  const refs = [useRef(), useRef(), useRef(), useRef()];

  const [formData, setFormData] = useState({
    id: '',
    name: '',
    idNumber: '',
    gender: '',
    dateOfBirth: '',
    dateOfJoining: '',
    City: '',
    roleId: '',
    branchId: '',
    branchIds: [], // 🔹 NEW: list of selected branch IDs
    restaurantId: '',
    State: 'Active',
    shiftNumber: '',
    JobTitle: '',
    LicenseNumber: '',
    address: '',
    phoneNumber: '',
    email: '',
    shiftClosingTime: '',
    shiftOpeningTime: '',
    user: '',
  });

  useEffect(() => {
    if (location?.state && location?.state?.val) {
      const { val } = location.state;

      setFormData((prev) => ({
        ...prev,
        id: val?.id || '',
        name: val?.name || '',
        idNumber: val?.idNumber || '',
        gender: val?.gender || '',
        dateOfBirth: val?.dateOfBirth ? moment(val?.dateOfBirth).format('YYYY-MM-DD') : '',
        dateOfJoining: val?.dateOfJoining ? moment(val?.dateOfJoining).format('YYYY-MM-DD') : '',
        City: val?.city || '',
        State: val?.state || 'Active',
        Shift: val?.shift || 1,
        JobTitle: val?.jobTitle || '',
        BranchId: val?.branchId || '',
        LicenseNumber: val?.LicenseNumber || '',
        address: val?.address || '',
        phoneNumber: val?.contactNumber || '',
        email: val?.email || '',
      }));
    }
    getRoles();
    getRestaurant();
  }, [location.state]);

  const getRoles = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_ROLE');
      const UserRes = await apiService.get('GET_USER_DROP');
      setRoles(res.data.result);
      setUserList(UserRes.data.result);
    } catch (error) {
      console.error('Error fetching User Roles:', error);
    }
  };

  const getRestaurant = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_RESTAURANT');
      const filter = res.data.result.filter((res) => res.isActive === true);
      setRestaurant(filter);
    } catch (error) {
      console.error('Error fetching Restaurants:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'dateOfBirth') {
      const inputDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (inputDate > today) {
        toast.error('Please Enter a valid Date');
        return;
      }

      setFormData({ ...formData, [name]: value });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption);
    debugger;
    setFormData((prev) => ({
      ...prev,
      roleId: selectedOption?.value?.roleId,
    }));

    // 🔹 If role itself is "Admin", also allow multi-branch
    const roleName = (selectedOption?.value?.role || '').toString().toLowerCase();
    const roleIsAdmin = roleName === 'admin';
    setIsAdminUser(roleIsAdmin);

    if (!roleIsAdmin) {
      // reset multi-branch if leaving admin
      setSelectedBranches([]);
      setFormData((prev) => ({
        ...prev,
        branchIds: [],
      }));
    }
  };

  const handleAddCostumer = async (e) => {
    e.preventDefault();
    try {
      if (formData?.shiftNumber == null) {
        toast.error('Please Choose shift ');
        return;
      } else if (!formData?.user?.value?.userNo) {
        toast.warning('Please Select User');
        return;
      }

      const shiftOpeningFormatted = moment(formData?.shiftOpeningTime, 'HH:mm').format('HH:mm:ss.SSSSSSS');
      const shiftClosingFormatted = moment(formData?.shiftClosingTime, 'HH:mm').format('HH:mm:ss.SSSSSSS');

      const otpString = otp?.join('');

      // 🔹 Build branchIds array fallback
      const branchIds = (formData.branchIds && formData.branchIds.length ? formData.branchIds : formData.branchId ? [formData.branchId] : []).map((id) =>
        Number(id)
      );

      const body = {
        employee_Name: formData?.name || '',
        department: selectedRole?.value?.name || '',
        exp1: formData?.idNumber || '',
        phoneNumber: formData?.phoneNumber || '',
        exp3: formData?.address || '',
        restaurantId: formData?.restaurantId || '1',
        roleId: formData?.roleId || '',
        branchId: branchIds[0] || '1', // keep first for backward compatibility
        branchIds: branchIds, // 🔹 NEW: send full list to API
        email: formData?.email || '',
        city: formData?.City || '',
        createdBy: userID || '',
        dob: moment.utc(formData?.dateOfBirth).format('YYYY-MM-DDTHH:mm:ss.SSS'),
        joiningDate: moment.utc(formData?.dateOfJoining).format('YYYY-MM-DDTHH:mm:ss.SSS'),
        shiftClosingTime: shiftOpeningFormatted,
        shiftOpeningTime: shiftClosingFormatted,
        shiftNumber: formData?.shiftNumber,
        userId: formData?.user?.value?.userNo,
        passCode: otpString || '',
      };

      const apiService = new ApiService();
      let response = await apiService.post('ADD_EMPLOYEE', body);

      if (response.data.statusCode === 201) {
        toast.success(response.data.message);
        navigate(`/admin/employee`);
      } else {
        toast.warning(response.data.message);
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleUpdateCostumer = async (e) => {
    e.preventDefault();
    try {
      const branchIds = (formData.branchIds && formData.branchIds.length ? formData.branchIds : formData.branchId ? [formData.branchId] : []).map((id) =>
        Number(id)
      );

      const body = {
        employee_Name: formData.name,
        department: formData.JobTitle,
        exp1: formData.idNumber,
        exp2: formData.phoneNumber,
        exp3: formData.address,
        restaurantId: formData?.restaurantId,
        roleId: formData?.roleId,
        branchId: branchIds[0] || null,
        branchIds: branchIds, // 🔹 NEW
      };

      const apiService = new ApiService();
      let response = await apiService.post('UPDATE_EMPLOYEE', body);

      if (response.data.statusCode === 204) {
        toast.success('Employee Updated successfully');
        navigate(`/admin/employee`);
      } else {
        toast.warning('Waiting for menu update');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const Gender = [
    { label: `${t('Male')}`, value: 'Male' },
    { label: `${t('Female')}`, value: 'Female' },
  ];

  const handleGenderChange = (selectedOption) => {
    setFormData({ ...formData, gender: selectedOption?.value });
  };

  const getBranches = async (restaurantId) => {
    try {
      const apiService = new ApiService();
      let param = `?restaurantId=${restaurantId}`;
      let res = await apiService.getApiParamater('GET_BRANCH', param);
      const filter = res.data.result.filter((res) => res.isActive === true);
      setBranches(filter);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  const handleRestaurantChange = (selectedOption) => {
    setSelectedRestaurant(selectedOption);
    const resId = selectedOption?.value?.id;
    getBranches(resId);
    setFormData((prev) => ({
      ...prev,
      restaurantId: resId,
      branchId: '',
      branchIds: [],
    }));
    setSelectedBranch(null);
    setSelectedBranches([]);
  };

  // 🔹 Branch selection: supports single or multi based on isAdminUser
  const handleBranchChange = (selectedOption) => {
    if (isAdminUser) {
      // Multi-select
      const options = selectedOption || [];
      setSelectedBranches(options);
      setSelectedBranch(null);

      const branchIds = options.map((opt) => opt.value.id);
      setFormData((prev) => ({
        ...prev,
        branchIds,
        branchId: branchIds[0] || '',
      }));
    } else {
      // Single-select
      setSelectedBranch(selectedOption);
      setSelectedBranches([]);
      const id = selectedOption?.value?.id || '';
      setFormData((prev) => ({
        ...prev,
        branchId: id,
        branchIds: id ? [id] : [],
      }));
    }
  };

  const handleShiftChange = (selectedOption) => {
    setSelectedShift(selectedOption);
    setFormData({ ...formData, shiftNumber: selectedOption?.value });
  };

  // 🔹 When user is selected, detect if that user is Admin
  const handleUserSelect = (selectedOption) => {
    const user = selectedOption?.value;
    setFormData((prev) => ({
      ...prev,
      user: selectedOption,
    }));

    const roleName = (user?.role || user?.roleName || user?.userRole || '').toString().toLowerCase();
    const userIsAdmin = roleName === 'admin';
    setIsAdminUser(userIsAdmin);

    // reset branches when switching role type
    setSelectedBranch(null);
    setSelectedBranches([]);
    setFormData((prev) => ({
      ...prev,
      branchId: '',
      branchIds: [],
    }));
  };

  const handleBackClick = () => {
    window.history.back();
  };

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numeric values
    const updatedOTP = [...otp];
    updatedOTP[index] = value.slice(-1);
    setOTP(updatedOTP);

    if (value !== '' && index < 3) {
      refs[index + 1].current.focus();
    }
  };

  return (
    <div className="p-lg-5 ">
      <form>
        <div className="d-flex justify-contant-between ">
          <h5 className="col mainInvHead">
            {t('create')} {t('employees')}
          </h5>
          <div className="d-flex justify-content-end gap-1">
            <div className="col center">
              {location?.state?.val?.name ? (
                <div className="end">
                  <button className="addItem-btn" type="submit" onClick={handleUpdateCostumer}>
                    <FaSave className="center mt-1 mx-2" />
                    {t('update')}
                  </button>
                </div>
              ) : (
                <div className="end">
                  <button className="addItem-btn" type="submit" onClick={handleAddCostumer}>
                    <FaSave className="center mt-1 mx-2" />
                    {t('save')}
                  </button>
                </div>
              )}
            </div>
            <button onClick={handleBackClick} className="mainbtnSecondary center" type="button">
              <FaAngleLeft className="center mt-1 mx-2" />
              <div>{t('back')}</div>
            </button>
          </div>
        </div>
        <div className="py-lg-5">
          {/* BASIC INFO */}
          <div className="cost-center-section mb-2">
            <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setCostTab(!CostTab)}>
              <div className="h6 pt-1">{t('basic_information')}</div>
            </div>
            <div className={`slide-content ${CostTab ? 'open' : 'closed'}`}>
              <div className="border-box2 p-3">
                <div className="form-group row justify-content-between">
                  <div className="col-md-3">
                    <label htmlFor="validationCustom01" className="form-label">
                      {t('name')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom01"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom02" className="form-label">
                      {t('email')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom02"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom03" className="form-label">
                      {t('address')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom03"
                      name="address"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom04" className="form-label">
                      {t('gender')}
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      value={Gender.find((g) => g.value === formData.gender) || null}
                      onChange={handleGenderChange}
                      options={Gender}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                    />
                  </div>
                </div>
                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-3">
                    <label htmlFor="validationCustom13" className="form-label">
                      {t('license_number')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom13"
                      name="LicenseNumber"
                      value={formData.LicenseNumber}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom05" className="form-label">
                      {t('contact_number')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom05"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom08" className="form-label">
                      {t('city')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom08"
                      name="City"
                      value={formData.City}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom06" className="form-label">
                      {t('id_number')}
                    </label>
                    <input
                      type="number"
                      className="p-2 form-control"
                      id="validationCustom06"
                      name="idNumber"
                      value={formData.idNumber}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="form-group row mt-3">
                  <div className="col-md-3">
                    <label htmlFor="validationCustom07" className="form-label">
                      {t('date_of_birth')}
                    </label>
                    <input
                      type="date"
                      className="p-2 form-control"
                      id="validationCustom07"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom11" className="form-label">
                      {t('userList')} *
                    </label>
                    <Select
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      id="Shift"
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      onChange={handleUserSelect}
                      value={formData?.user}
                      options={userList?.map((user) => ({
                        value: user,
                        label: user.userName,
                      }))}
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="form-label center"> {t('pass_code')} *</label>
                    <div className="d-flex center">
                      {[0, 1, 2, 3].map((index) => (
                        <input
                          key={index}
                          type="number"
                          maxLength={1}
                          value={otp[index]}
                          onChange={(e) => handleOtpChange(index, e.target.value)}
                          ref={refs[index]}
                          className="otpbx"
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* JOB INFO */}
          <div className="cost-center-section mb-2">
            <div className="d-flex mt-3 cursor-pointer slide-header gap-4" onClick={() => setDetail(!detail)}>
              <div className="h6 pt-1">{t('jon_information')}</div>
            </div>
            <div className={`slide-content ${detail ? 'open' : 'closed'}`}>
              <div className="border-box2 p-3">
                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-3">
                    <label htmlFor="roleSelect" className="form-label">
                      {t('role')}
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      id="roleSelect"
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={Roles?.map((role) => ({
                        value: role,
                        label: role.role,
                      }))}
                      value={selectedRole}
                      onChange={handleRoleChange}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="restaurantSelect" className="form-label">
                      {t('Select_Company')}
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      id="restaurantSelect"
                      value={selectedRestaurant}
                      onChange={handleRestaurantChange}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={Restaurants?.map((restaurant) => ({
                        value: restaurant,
                        label: restaurant.name,
                      }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="branchSelect" className="form-label">
                      {t('select')} {t('branches')}
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      id="branchSelect"
                      isMulti={isAdminUser} // 🔹 multi only for admin
                      value={isAdminUser ? selectedBranches : selectedBranch}
                      onChange={handleBranchChange}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={branches?.map((branch) => ({
                        value: branch,
                        label: branch.branchName,
                      }))}
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom11" className="form-label">
                      {t('shift')}
                    </label>
                    <Select
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      id="Shift"
                      value={selectedShift}
                      onChange={handleShiftChange}
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      menuShouldScrollIntoView={false}
                      options={shiftEnums?.map((shift) => ({
                        value: shift.type,
                        label: shift.value,
                      }))}
                    />
                  </div>
                </div>
                <div className="form-group row mt-3 justify-content-between">
                  <div className="col-md-3">
                    <label htmlFor="validationCustom09" className="form-label">
                      {t('date_of_joining')}
                    </label>
                    <input
                      type="date"
                      className="p-2 form-control"
                      id="validationCustom09"
                      name="dateOfJoining"
                      value={formData.dateOfJoining}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="shiftOpeningTime" className="form-label">
                      {t('shift_opening_time')}
                    </label>
                    <input
                      type="time"
                      placeholder="HH:MM"
                      className="p-2 form-control"
                      id="shiftOpeningTime"
                      name="shiftOpeningTime"
                      value={formData?.shiftOpeningTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="shiftClosingTime" className="form-label">
                      {t('shift_close_time')}
                    </label>
                    <input
                      type="time"
                      placeholder="HH:MM"
                      className="p-2 form-control"
                      id="shiftClosingTime"
                      name="shiftClosingTime"
                      value={formData.shiftClosingTime}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="col-md-3">
                    <label htmlFor="validationCustom12" className="form-label">
                      {t('job_title')}
                    </label>
                    <input
                      type="text"
                      className="p-2 form-control"
                      id="validationCustom12"
                      name="JobTitle"
                      value={formData.JobTitle}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddEmployee;
